import type { IEvent } from 'src/shared/types/event';
import type { INetwork } from 'src/shared/types/network';

import { getApiUrl } from 'src/shared/utils/get-api-url';
import { mockRequest } from 'src/shared/api/utils/mock-request';

import { baseApi } from '../base-api';

import type { IFilters, IPagination, PaginatedResponse } from '../types';
import type {
  IVerifyEventRequest,
  IGetEventsCountsResponse,
  IGetEventStatisticsResponse,
} from './types';

const isStubEnabled = import.meta.env.VITE_EVENT_HISTORY_API_STUB === 'true';

const api = baseApi.extend({});

export const apiEventHistory = {
  getEvents: async (body?: IFilters & IPagination) =>
    // if (isStubEnabled) {
    //   return await mockRequest<IEvent[]>(getAllEventsResponse as IEvent[]);
    // }

    await api
      .post<PaginatedResponse<IEvent>>(`${getApiUrl(3)}/EventHistory`, {
        json: body,
      })
      .json(),
  getEvent: async (bloggerEventId: string) =>
    await api
      .post<IEvent>(`${getApiUrl(3)}/EventHistory/EventHistory/${bloggerEventId}`, {
        json: {},
      })
      .json(),
  getAvailableEvents: async (body?: IFilters & IPagination) =>
    await api
      .post<PaginatedResponse<IEvent>>(`${getApiUrl(3)}/EventHistory/Available`, {
        json: body,
      })
      .json(),
  verifyEvent: async (data: IVerifyEventRequest) => {
    if (isStubEnabled) {
      return await mockRequest(true);
    }

    return await api
      .put<IEvent>(`${getApiUrl(3)}/EventHistory/VerifyEvent`, {
        json: { eventId: data.bloggerEventId, isVerified: data.isVerified },
      })
      .json();
  },
  setVerifiedEvents: async (bloggerEventIds: string[], isVerified: boolean) =>
    await api
      .put(`${getApiUrl(3)}/EventHistory/BulkVerify`, {
        json: { bloggerEventIds, isVerified },
      })
      .json(),
  setFavoritesEvents: async (eventIds: string[], isFavorite: boolean) =>
    await api
      .put(`${getApiUrl(3)}/EventHistory/Favorites`, {
        json: { eventIds, isFavorite },
      })
      .json(),
  setHiddenEvents: async (eventIds: string[], isHidden: boolean) =>
    await api
      .put(`${getApiUrl(3)}/EventHistory/SetHidden`, {
        json: { eventIds, isHidden },
      })
      .json(),
  getEventStatistics: async (bloggerEventId: string) =>
    await api
      .get<IGetEventStatisticsResponse>(
        `${getApiUrl(3)}/EventHistory/event-statistics/${bloggerEventId}`
      )
      .json(),
  getEventsCounts: async () =>
    await api.get<IGetEventsCountsResponse>(`${getApiUrl(3)}/EventHistory/summary`).json(),
  createSocialNetworkRequest: async (bloggerEventId: string, socialNetworkId: string) =>
    await api
      .post(`${getApiUrl(3)}/EventHistory/RequestSocialNetwork`, {
        json: { bloggerEventId, socialNetworkId },
      })
      .json(),
  getAvailableSocialNetworksForRequest: async (bloggerEventId: string) =>
    await api
      .get<INetwork[]>(`${getApiUrl(3)}/EventHistory/AvailableSocialNetworks/${bloggerEventId}`)
      .json(),
};
